import api from "@/lib/api";

// A/B hero: the variant assigned by /promo/hero is kept in localStorage and sent back as X-AB-Variant (signup attribution).
export const AB_KEY = "mf_ab";
export const abVariant = () => { try { return localStorage.getItem(AB_KEY); } catch { return null; } };
export const setAbVariant = (v) => { try { if (v) localStorage.setItem(AB_KEY, v); } catch { /* private mode */ } };

export function abEvent(kind) {
  const v = abVariant();
  if (!v) return;
  api.post("/promo/ab/event", { variant: v, kind }).catch(() => {});
}
